module.exports = __webpack_public_path__ + "static/media/zidi-capital-sacco-logo.4def7910.jfif";